import React from 'react'

const EMCtestSystem = () => {
    return (
        <>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Rohde & Schwarz</a>
                        <i class="fa fa-angle-right"></i>
                        <a href="/">EMC Test Equipments
                        </a>
                        <i class="fa fa-angle-right"></i>
                        <span>EMC Test System </span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div>
                    <h1 className='text-center ' style={{ textDecoration: "underline" }}>EMC Test System </h1>
                </div>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/emctestsystem.png' width={250} ></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>Scalable flexible turn-key systems for EMC test:</h2>
                        <p class="mbot25">
                            Description: Certifiable all-in-one EMI/EMS test platform for commercial standards<br />
                            Application: For EMI/EMS precompliance and certification tests and all common frequency ranges and field strenghts.
                        </p>
                        <h2 style={{ textDecoration: "underline" }}>Key facts</h2>
                        <p class="mbot25">
                            <ul>
                                <li>Certifiable base system for commercial standards</li>
                                <li>EMS measurements from 80 MHz to 3 GHz, 10 V/m</li>
                                <li>EMS and EMI measurements without changing antennas</li>
                                <li>Scalable and expandable for further EMC applications</li>
                                <li>Various proven EUT monitoring capabilities</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EMCtestSystem
